import React, { useState } from "react";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CloseIcon from "@mui/icons-material/Close";

const GpsNoticeBanner = () => {
    const [visible, setVisible] = useState(true);

    if (!visible) return null;

    return (
        <div className="gps_notice_banner">
            <div className="gps_notice_banner__content">
                <WarningAmberIcon className="gps_notice_banner__icon" />
                <span className="gps_notice_banner__text">
                    <strong>NOTICE:</strong> GPS location updates may be delayed or less accurate when vehicles pass through security-sensitive areas.
                </span>
            </div>
            <button
                className="gps_notice_banner__close"
                onClick={() => setVisible(false)}
                aria-label="Dismiss GPS notice"
                title="Dismiss"
            >
                <CloseIcon fontSize="small" />
            </button>
        </div>
    );
};

export default GpsNoticeBanner;
